module.exports = __webpack_public_path__ + "static/media/ins.8121dc91.png";